import { render, staticRenderFns } from "./OrderDraftPayments.vue?vue&type=template&id=131e5cdd&"
import script from "./OrderDraftPayments.vue?vue&type=script&lang=js&"
export * from "./OrderDraftPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports